import Vue from 'vue';
import Vuex from 'vuex';
// Stores
import likes from './likes';
import news from './news';
import login from './login';
import event from './event';
import events from './events';
import basket from './basket';
import profile from './profile';
import landing from './landing';
import multimedia from './multimedia';
import banner from './banner';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    news,
    likes,
    login,
    event,
    events,
    basket,
    profile,
    landing,
    multimedia,
    banner
  },
});
